import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import Modal from "antd/lib/modal";
import "./NetworkDeepdive.scss";
import somethingWentWrong from "../../../../../assets/No_Data_Found.svg";
import BackBtn from "../../../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../../../assets/WhiteIcons/BackArrow_White.svg";
import {
  getBrands,
  getCustomizedDate,
  getPaneIndex,
  getWindowLocationPath,
} from "../../../../../redux/constants";
import moment from "moment";
import {
  getNetworkDeepdiveData,
  setNetworkDeepdiveData,
} from "../../../../../redux/actions/Network";
import MultiClusterNetworkGraphV2 from "./MultiClusterNetworkGraphV2";
import NoGraphData from "../../../../workspace/DisplayChart/NoGraphData";
import ErrorBoundary from "../../../../../ErrorBoundary";
import MultiNetowrkGraphUsingClusteringV2 from "./MultiNetowrkGraphUsingClusteringV2";
import AuthorDetailsWithPosts from "./AuthorDetailsWithPosts";
import { Tooltip } from "antd";
const NetworkDeepdive = ({
  networkDeepDiveObj,
  setNetworkDeepDiveObj,
  isNetworkModalOpen,
  isVisNetworkGraph,
  section_index,
  widget_index,
  metadata,
  style,
  PdfDownloadStatus,
  id,
  type,
  dashboard,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const networkDeepLoader = useSelector((state) => state?.Network?.loader);
  const networkDeepDiveData = useSelector(
    (state) => state?.Network?.deepDiveData
  );

  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const screenRefreshEvent = useSelector(
    (state) => state?.Screens?.refreshEvent
  );
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state?.ApiCall?.brandlogicalgroup?.data?.result
  );
  const [deepDiveMetaData, setDeepDiveMetaData] = useState(null);
  const [deepDiveApiCallStatus, setDeepDiveApiCallStatus] = useState(false);

  useEffect(() => {
    try {
      if (networkDeepDiveObj && !deepDiveMetaData) {
        let pathName = getWindowLocationPath()?.toLowerCase();

        if (
          panes?.[getPaneIndex(panes, activeKey)]?.isDashboard ||
          (shareBrands && shareableLinkDeepDiveStatus) ||
          pathName === "CommandCenter"?.toLowerCase()
        ) {
          let index =
            !shareBrands &&
            pathName !== "CommandCenter"?.toLowerCase() &&
            getPaneIndex(panes, activeKey);
          let shareSections = shareTemplateData?.section
            ? shareTemplateData?.section?.[0]
            : shareTemplateData?.sections?.[section_index];
          let widget_metadata =
            pathName === "CommandCenter"?.toLowerCase()
              ? section_index !== null &&
                section_index !== undefined &&
                screen?.sections &&
                screen?.sections?.[section_index]?.widgets?.[widget_index]
                ? screen?.sections?.[section_index]?.widgets?.[widget_index]
                : screen?.section?.[0]?.widgets?.[widget_index]
                ? screen?.section?.[0]?.widgets?.[widget_index]
                : screen?.widgets
                ? screen?.widgets?.[widget_index]
                : null
              : shareBrands
              ? shareSections?.widgets?.[widget_index]
              : section_index >= 0 && panes?.[index]?.sections
              ? panes?.[index]?.sections?.[section_index]?.widgets?.[
                  widget_index
                ]
              : panes?.[index]?.section?.[0]?.widgets?.[widget_index];
          let updatedWidgetMetaData = structuredClone(widget_metadata);
          delete updatedWidgetMetaData?.graphData;
          delete updatedWidgetMetaData?.persist_graphdata;
          setDeepDiveMetaData(updatedWidgetMetaData);
        }
      }
    } catch (error) {
      console.error("Error on NetworkDeepdive : Meta Data Setting :  ", error);
    }
  }, [networkDeepDiveObj]);

  // after deepDiveMetaData set call api for get network graph for deepdive
  useEffect(() => {
    try {
      if (deepDiveMetaData && !deepDiveApiCallStatus) {
        setDeepDiveApiCallStatus(true);
        if (deepDiveMetaData?.payload) {
          const payloadObj = {
            body: deepDiveMetaData?.payload,
            u_authorid: networkDeepDiveObj?.u_authorid,
            widget_id: networkDeepDiveObj?.isretweetauthor ? "NG-3" : "NG-2",
            payload: true,
            data_source: "network",
            isCommandCenter: authParams?.screen_id ? false : false,
          };
          authParams && dispatch(getNetworkDeepdiveData(payloadObj));
        }
      }
    } catch (error) {
      console.error("Error on NetworkDeepdive : Api Call :  ", error);
    }
  }, [deepDiveMetaData]);

  const handleSettingChange = (updatedProps) => {
    let updatedDeepDiveMetaData = structuredClone(deepDiveMetaData);
    let updatedPaylaod = structuredClone(updatedDeepDiveMetaData?.payload);

    if (updatedProps && Array.isArray(updatedProps)) {
      updatedProps?.forEach((propData) => {
        updatedDeepDiveMetaData[propData?.prop_name] = Array.isArray(
          propData?.prop_value
        )
          ? [...propData?.prop_value]
          : typeof propData?.prop_value === "object"
          ? { ...propData?.prop_value }
          : propData?.prop_value;
        updatedPaylaod[propData?.prop_name] = Array.isArray(
          propData?.prop_value
        )
          ? [...propData?.prop_value]
          : typeof propData?.prop_value === "object"
          ? { ...propData?.prop_value }
          : propData?.prop_value;
      });
    } else {
      updatedDeepDiveMetaData[updatedProps?.prop_name] = Array.isArray(
        updatedProps?.prop_value
      )
        ? [...updatedProps?.prop_value]
        : typeof updatedProps?.prop_value === "object"
        ? { ...updatedProps?.prop_value }
        : updatedProps?.prop_value;
      updatedPaylaod[updatedProps?.prop_name] = Array.isArray(
        updatedProps?.prop_value
      )
        ? [...updatedProps?.prop_value]
        : typeof updatedProps?.prop_value === "object"
        ? { ...updatedProps?.prop_value }
        : updatedProps?.prop_value;
    }
    updatedDeepDiveMetaData.payload = updatedPaylaod;
    delete updatedDeepDiveMetaData?.graphData;
    delete updatedDeepDiveMetaData?.persist_graphdata;
    setDeepDiveApiCallStatus(false);
    setDeepDiveMetaData(updatedDeepDiveMetaData);
  };
  // useEffect(() => {
  //   console.log("\n\n\nuseEffect got called : on initial network ");
  //   console.log("network deepdive : ", network);
  // }, [network]);

  const deepDiveGraphData = useMemo(() => {
    if (networkDeepDiveData) {
      return typeof networkDeepDiveData === "string"
        ? networkDeepDiveData
        : networkDeepDiveData?.data?.[
            metadata?.chart?.chart_type
              ? metadata?.chart?.chart_type
              : metadata?.chart_type
          ];
    } else {
      return null;
    }
  }, [networkDeepDiveData]);

  const handleCancel = () => {
    if (isVisNetworkGraph) {
      setNetworkDeepDiveObj(null);
    }
    setDeepDiveApiCallStatus(false);
    dispatch(setNetworkDeepdiveData(null));
  };
  return (
    <>
      <Modal
        title={
          <div className="d-flex align-items-center justify-content-between">
            <div className="text_heading-Slab font-size16 font-weight500 d-flex">
              <Tooltip title={"Back"}>
                <img
                  onClick={() => handleCancel()}
                  className="NetwokDeepdive__modal__header--backIcon cursor-pointer"
                  src={
                    authParams?.theme_type === "1" ? BackArrowWhite : BackBtn
                  }
                  alt="Back Arrow"
                />
              </Tooltip>
              Network Deepdive Analysis
            </div>
          </div>
        }
        closable={false}
        mask={false}
        maskClosable={false}
        footer={null}
        open={isNetworkModalOpen}
        onOk={handleCancel}
        onCancel={handleCancel}
        width={"100%"}
        height={"100%"}
        // style={{ top: "2rem" }}
        className={`NetwokDeepdive__modal ${
          authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
        }`}
      >
        <div className="NetwokDeepdive__modal--content">
          <div className="NetwokDeepdive__modal--graph">
            {networkDeepLoader ? (
              <div className="loader h-100">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : typeof networkDeepDiveData !== "string" && deepDiveGraphData ? (
              <>
                <MultiNetowrkGraphUsingClusteringV2
                  metadata={deepDiveMetaData}
                  widget_index={widget_index}
                  section_index={section_index}
                  single={
                    deepDiveGraphData?.[0]?.data
                      ? deepDiveGraphData?.[0]?.data
                      : deepDiveGraphData
                  }
                  networkLinkLength={
                    deepDiveGraphData?.[0]?.link_length
                      ? deepDiveGraphData?.[0]?.link_length
                      : deepDiveGraphData?.link_length
                  }
                  style={{ width: "100%", height: "100%" }}
                  desc={
                    deepDiveGraphData?.[0]?.description
                      ? deepDiveGraphData?.[0]?.description
                      : deepDiveGraphData?.description
                  }
                  log={
                    deepDiveGraphData?.[0]?.log
                      ? deepDiveGraphData?.[0]?.log
                      : deepDiveGraphData?.log
                  }
                  scaleFromZeroToOne={
                    deepDiveGraphData?.[0]?.scale_from_0_to_1
                      ? deepDiveGraphData?.[0]?.scale_from_0_to_1
                      : deepDiveGraphData?.scale_from_0_to_1
                  }
                  id={`NetworkGraphDeepDive_${id ? id : type}`}
                  type={
                    deepDiveMetaData?.chart?.chart_type
                      ? deepDiveMetaData?.chart?.chart_type
                      : deepDiveMetaData?.chart_type
                  }
                  legend_position={
                    deepDiveMetaData?.chart?.chart_settings?.chart_property
                      ?.legend_position
                      ? deepDiveMetaData?.chart?.chart_settings?.chart_property
                          ?.legend_position
                      : deepDiveMetaData?.chart_property?.legend_position
                  }
                  chartGlobalDataLabel={
                    deepDiveMetaData?.chart?.chart_settings?.show_data_labels
                      ? deepDiveMetaData?.chart?.chart_settings
                          ?.show_data_labels
                      : deepDiveMetaData?.show_data_labels
                  }
                  chartShowDetailsOnCard={
                    deepDiveMetaData?.chart?.chart_settings
                      ?.show_details_on_card
                      ? deepDiveMetaData?.chart?.chart_settings
                          ?.show_details_on_card
                      : deepDiveMetaData?.show_details_on_card
                  }
                  chartDataLabelInPercent={
                    deepDiveMetaData?.chart?.chart_settings?.chart_percent
                      ? deepDiveMetaData?.chart?.chart_settings?.chart_percent
                      : deepDiveMetaData?.chart_percent
                  }
                  chartGradientColor={
                    deepDiveMetaData?.chart?.chart_settings?.gradient_color
                      ? deepDiveMetaData?.chart?.chart_settings?.gradient_color
                      : deepDiveMetaData?.gradient_color
                  }
                  chartGlobalDataStacked={
                    deepDiveMetaData?.chart?.chart_settings?.is_stacked
                      ? deepDiveMetaData?.chart?.chart_settings?.is_stacked
                      : deepDiveMetaData?.is_stacked
                  }
                  chartMarkers={
                    deepDiveMetaData?.chart?.chart_settings?.show_marker
                      ? deepDiveMetaData?.chart?.chart_settings?.show_marker
                      : deepDiveMetaData?.show_marker
                  }
                  PdfDownloadStatus={PdfDownloadStatus}
                  isNetworkDeepDive={true}
                  hideSetting={networkDeepDiveObj?.isretweetauthor}
                  onSettingChange={handleSettingChange}
                  dashboard={dashboard}
                />
                {/* <MultiClusterNetworkGraphV2
              metadata={metadata}
              widget_index={widget_index}
              section_index={section_index}
              single={
                deepDiveGraphData?.[0]?.data
                  ? deepDiveGraphData?.[0]?.data
                  : deepDiveGraphData
              }
              networkLinkLength={
                deepDiveGraphData?.[0]?.link_length
                  ? deepDiveGraphData?.[0]?.link_length
                  : deepDiveGraphData?.link_length
              }
              style={{ width: "100%", height: "100%" }}
              desc={
                deepDiveGraphData?.[0]?.description
                  ? deepDiveGraphData?.[0]?.description
                  : deepDiveGraphData?.description
              }
              log={
                deepDiveGraphData?.[0]?.log
                  ? deepDiveGraphData?.[0]?.log
                  : deepDiveGraphData?.log
              }
              scale_from_0_to_1
              scaleFromZeroToOne={
                deepDiveGraphData?.[0]?.scale_from_0_to_1
                  ? deepDiveGraphData?.[0]?.scale_from_0_to_1
                  : deepDiveGraphData?.scale_from_0_to_1
              }
              id={`NetworkGraphDeepDive_${id ? id : type}`}
              type={
                metadata?.chart?.chart_type
                  ? metadata?.chart?.chart_type
                  : metadata?.chart_type
              }
              legend_position={
                metadata?.chart?.chart_settings?.chart_property?.legend_position
                  ? metadata?.chart?.chart_settings?.chart_property
                      ?.legend_position
                  : metadata?.chart_property?.legend_position
              }
              chartGlobalDataLabel={
                metadata?.chart?.chart_settings?.show_data_labels
                  ? metadata?.chart?.chart_settings?.show_data_labels
                  : metadata?.show_data_labels
              }
              chartDataLabelInPercent={
                metadata?.chart?.chart_settings?.chart_percent
                  ? metadata?.chart?.chart_settings?.chart_percent
                  : metadata?.chart_percent
              }
              chartGradientColor={
                metadata?.chart?.chart_settings?.gradient_color
                  ? metadata?.chart?.chart_settings?.gradient_color
                  : metadata?.gradient_color
              }
              chartGlobalDataStacked={
                metadata?.chart?.chart_settings?.is_stacked
                  ? metadata?.chart?.chart_settings?.is_stacked
                  : metadata?.is_stacked
              }
              chartMarkers={
                metadata?.chart?.chart_settings?.show_marker
                  ? metadata?.chart?.chart_settings?.show_marker
                  : metadata?.show_marker
              }
              PdfDownloadStatus={PdfDownloadStatus}
              isNetworkDeepDive={true}
            ></MultiClusterNetworkGraphV2> */}
              </>
            ) : (
              <div className="portlet_images d-flex text-center h-100">
                <div className="m-auto">
                  <ErrorBoundary>
                    <NoGraphData
                      errorCode="No Data Found"
                      isCommandCenterScreen={true}
                    />
                  </ErrorBoundary>
                  {/* <img
                alt="no data"
                src={somethingWentWrong}
                style={{ maxWidth: "100%", minWidth: "20rem" }}
              />
              <p className="mt-15 text_regular-gray">No Data Found</p> */}
                </div>
              </div>
            )}
          </div>
          <div className="NetwokDeepdive__modal--authorPostDetails">
            <AuthorDetailsWithPosts
              networkDeepDiveObj={networkDeepDiveObj}
              isNetworkModalOpen={networkDeepDiveObj ? true : false}
              isVisNetworkGraph={true}
              section_index={section_index}
              widget_index={widget_index}
              metadata={metadata}
              style={style}
              id={id}
              PdfDownloadStatus={PdfDownloadStatus}
              type={type}
              dashboard={dashboard}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default React.memo(NetworkDeepdive, isEqual);
